import http from '@/utils/http';

export default {
    // 获取等效分
    getUserAccurateScore(data) {
        return http({
            url: 'Accurate/GetUserScore',
            params: data,
            method: 'POST'
        });
    },
    // 获取表头
    getColumnName() {
        return http({
            url: 'Accurate/GetColumnName'
        });
    },
    // 获取首选科目
    getPreferredSubject(data) {
        return http({
            url: 'Accurate/GetPreferredSubject',
            params: data
        });
    },
    // 获取选考科目
    getRequirementsSubjects(data) {
        return http({
            url: 'Accurate/GetRequirementsSubjects',
            params: data
        });
    },
    // 院校地区
    getAccurateCity(data) {
        return http({
            url: 'Accurate/GetCitys'
        });
    },
    // 专业选择列表
    getAccurateGetProfession(data, showLoading = true) {
        return http({
            url: 'Accurate/GetProfession',
            method: 'POST',
            data,
            headers: {
                showLoading
            }
        });
    },
	getProfession2022(data, showLoading = true) {
	    return http({
	        url: 'Accurate/GetProfession2022',
	        method: 'POST',
	        data,
	        headers: {
	            showLoading
	        }
	    });
	},
    // 院校选择列表
    getAccurateGetAdmission(data, showLoading = true) {
        return http({
            url: 'Accurate/GetAdmission',
            method: 'POST',
            data,
            headers: {
                showLoading
            }
        });
    },
    // 精确选择保存
    accurateVolunteerSave(data) {
        return http({
            url: 'Accurate/VolunteerSave',
            method: 'POST',
            data
        });
    },
    // 添加/取消关注
    accurateAttentionAdd(data) {
        return http({
            url: 'Accurate/AttentionAdd',
            params: data
        });
    },
    // 获取志愿列表
    getVolunteerList(data) {
        return http({
            url: 'Accurate/VolunteerList',
            method: 'POST',
            data
        });
    },
    // 志愿表排序
    volunteerSetSort(data) {
        return http({
            url: 'Accurate/VolunteerSetSort',
            data,
            method: 'POST'
        });
    },
    // 获取excel下载地址
    getAccurateExcelUrl(data) {
        return http({
            url: 'SystemData/GetExcelFilePath',
            params: data,
            headers: {
                showLoading: false
            }
        });
    },
    // 获取pdf下载地址
    getAccuratePdfUrl(data) {
        return http({
            url: 'Accurate/DownloadPdf',
            params: data,
            headers: {
                showLoading: false
            }
        });
    },
    // 重新生成志愿表pdf
    reCreateVolunteerPdf(data) {
        return http({
            url: 'Accurate/ReCreatePDF',
            params: data,
            method: 'PUT'
        });
    },
    // 删除志愿
    accurateDeleteVolunteer(data) {
        return http({
            url: 'Accurate/VolunteerDelete',
            params: data
        });
    }
};
